import React, { useState } from "react";
import 조직 from "assets/images/에스마리나_조직.png"
import 회사 from "assets/images/회사개요 사용이미지.png"
import Com from "components/styledComp/CommStyledComp";
import CompImg from "./CompImg";
import Modal from "./Modal";

const CompanyIntro = () => {

    const [showModal, setShowModal] = useState(false);
    const handleImgClick = () => {
        setShowModal(true);
    };
    
    return (
        <Com.DivDetailSection4 border={true}>
            <Com.DivDetailHeading>
                <Com.DetailHeading>회사 개요</Com.DetailHeading>
                <Com.DetailHeadingP>sMarina</Com.DetailHeadingP>
                <div className="paragraph">
                에스마리나(주)는  2022년 6월 설립된 Smart Marina를 위한 Pedestal 개발, 제조 및<br/>통합 마리나 정보관리 시스템 개발, 운영 회사입니다.
                </div>
            </Com.DivDetailHeading>
            <div className="strategy">
                <Com.StrongStrategyCenter>조직 구조</Com.StrongStrategyCenter>
                <CompImg img={조직} width="100%" height="auto" onClick={handleImgClick}/>
            </div>
            <div className="op_content">
                <div className="gridorflex">
                    <Com.OlGaeyo>
                    <li>
                        <div className="Gaeyo-sec">
                            <Com.GaeyoTitle>Vision</Com.GaeyoTitle>
                            <Com.GaeyoOl>
                            Marina Pedestal을 중심으로 하는 마리나 항만 관리 솔루션을 Metaverse로 구현 하는 Marina Platform 구축
                            </Com.GaeyoOl>
                        </div>
                    </li>
                    <li>
                        <div className="Gaeyo-sec">
                            <Com.GaeyoTitle>Pedestal 통합</Com.GaeyoTitle>
                            <Com.GaeyoOl>
                            제조사에 의존적이지 않는 원격 제어 및 AMR 시스템
                            </Com.GaeyoOl>
                        </div>
                    </li>
                    <li>
                        <div className="Gaeyo-sec">
                            <Com.GaeyoTitle>마리나 항만 관리</Com.GaeyoTitle>
                            <Com.GaeyoOl>
                            계류 선박의 계류장 관리와 각종 센서를 통한 상태
                            정보를 전송, 관리 하는 시스템
                            </Com.GaeyoOl>
                        </div>
                    </li>     
                    </Com.OlGaeyo>   
                    <Com.IntroImg src={회사} alt="" width="85%" height="370px"/>
                </div>
            </div>
            {showModal && (
                <Modal onClose={() => setShowModal(false)}>
                    <img src={조직} alt="Full" style={{ width: "100%" }} />
                </Modal>
            )}
        </Com.DivDetailSection4>
    );
};

export default CompanyIntro;
